/*
 * @Description:
 * @Author: LiZhenlin
 * @Date: 2021-04-02 17:56:59
 */
/* eslint no-restricted-syntax:0 */
import { webviewInfo } from '@ali/amap-lib';

const host = window.location.hostname;
const productionHostList = [
  'wap.amap.com',
  'free-wap.amap.com',
  'prewap.amap.com',
  'activity.gaode.com  ',
  'activity2.gaode.com',
  'activity.anav.com ',
  'activity2.anav.com',
  'cache.amap.com',
  'free-cache.amap.com',
  'cache.gaode.com',
  'free-cache.gaode.com',
  'cache1.gaode.com',
  'cache1.autonavi.com',
  'm.autonavi.com'
];
const isPublic = webviewInfo.isPublic();
const isPreEnv = window.location.search.indexOf('pre') >= 0 && !productionHostList.some((item) => item === host); // 是否预发环境
console.log(`%cLINKURL 是否强制使用预发环境-->>${isPreEnv}`, 'color: orange');

const LINKURL = {}; // output
const linkURL = {
  // 注意此处https
  index: {
    test: 'https://testing.amap.com/activity/2021GasInviter/vweb_feature/1/index.html',
    pre: 'https://pre-cache.amap.com/activity/2021GasInviter/vweb_feature/1/index.html?pre=1',
    public: 'https://cache.amap.com/activity/2021GasInviter/index.html'
  },
  // 被邀请好友列表
  friendList: {
    test: 'https://testing.amap.com/activity/2021GasInviter/vweb_feature/1/friendList.html',
    pre: 'https://pre-cache.amap.com/activity/2021GasInviter/vweb_feature/1/friendList.html?pre=1',
    public: 'https://cache.amap.com/activity/2021GasInviter/friendList.html'
  },
  // 端外呼起页
  endPage: {
    test: 'https://testing.amap.com/activity/2021GasInviter/vweb_feature/1/endPage.html',
    pre: 'https://pre-cache.amap.com/activity/2021GasInviter/vweb_feature/1/endPage.html?pre=1',
    public: 'https://cache.amap.com/activity/2021GasInviter/endPage.html'
  },
  // 呼起页
  callNative: {
    test: 'https://testing.amap.com/activity/2020CommonLanding/index.html',
    public: 'https://cache.gaode.com/activity/2020CommonLanding/index.html'
  },
  // 我的奖品,AmapApp.util.goAward()
  awardlist: {
    test: 'https://testing.amap.com/public/activity/common/page/awardlist.html',
    public: 'https://cache.amap.com/activity/common/page/awardlist.html',
  },
  // 加油tab页
  gasSchema: {
    test: 'https://testing.amap.com/activity/2021GaodeAwardlist/index.html?tabId=1&tabType=gasstation',
    public: 'https://cache.gaode.com/activity/2021GaodeAwardlist/index.html?tabId=1&tabType=gasstation',
  },
  /*  其他接口 */
};

const preHost = 'h5-cms-test.oss-cn-hangzhou-zmf.aliyuncs.com';
Object.keys(linkURL).forEach((pagename) => {
  if (isPreEnv) {
    const hasPreEnv = linkURL[pagename].pre;
    if (!hasPreEnv) {
      const publicHost = new URL(linkURL[pagename].public).hostname;
      LINKURL[pagename] = linkURL[pagename].public.replace(publicHost, preHost);
    } else {
      LINKURL[pagename] = linkURL[pagename].pre;
    }
  } else if (isPublic) {
    LINKURL[pagename] = linkURL[pagename].public;
  } else {
    LINKURL[pagename] = linkURL[pagename].test;
  }
});

export default LINKURL;
